// Expense CRUD Reducer
// Handles expense creation and removal

import type { ClaimState, ClaimAction } from './types';

export function expenseReducer(state: ClaimState, action: ClaimAction): ClaimState | null {
  switch (action.type) {
    case 'ADD_EXPENSE':
      return {
        ...state,
        expenses: [...state.expenses, action.expense],
        isDirty: true,
      };

    case 'REMOVE_EXPENSE':
      return {
        ...state,
        expenses: state.expenses.filter((e) => e.id !== action.id),
        isDirty: true,
      };

    default:
      return null;
  }
}
